import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = a((s, l) => /* @__PURE__ */ c.jsx(
  r,
  {
    ref: l,
    ...s,
    image: (o) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...o,
        children: [
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8c.41 0 .75.34.75.75s-.34.75-.75.75C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24c0-.41.34-.75.75-.75s.75.34.75.75c0 8.82-7.18 16-16 16"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M32.01 19.57a3.56 3.56 0 0 1-3.55-3.56 3.56 3.56 0 0 1 3.55-3.56c1.96 0 3.55 1.6 3.55 3.56a3.56 3.56 0 0 1-3.55 3.56m0-5.62c-1.13 0-2.05.92-2.05 2.06s.92 2.06 2.05 2.06 2.05-.92 2.05-2.06-.92-2.06-2.05-2.06M28.1 12.86c-.19 0-.38-.07-.53-.22l-1.12-1.12a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.12 1.12c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22M37.02 21.79c-.19 0-.38-.07-.53-.22l-1.09-1.1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.09 1.1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22M35.96 12.8c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.06-1.06c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-1.06 1.06c-.15.15-.34.22-.53.22M26.98 21.79c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.15-1.16c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-1.15 1.16c-.14.15-.34.22-.53.22M26.66 16.76h-1.91c-.42 0-.75-.33-.75-.75s.34-.75.75-.75h1.91c.41 0 .75.34.75.75s-.34.75-.75.75M39.25 16.76H37.4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.85c.41 0 .75.34.75.75s-.34.75-.75.75M32 24.01c-.41 0-.75-.34-.75-.75v-1.91c0-.41.34-.75.75-.75s.75.34.75.75v1.91c0 .42-.34.75-.75.75M32 11.37c-.41 0-.75-.34-.75-.75V8.76c0-.41.34-.75.75-.75s.75.34.75.75v1.85c0 .42-.34.76-.75.76M23.93 33.08h-.24c-3.06-.1-5.53-2.04-6.3-4.94-.11-.4.13-.81.54-.92.4-.1.81.13.92.54.59 2.24 2.51 3.74 4.89 3.82 2.01.08 4.45-.92 5.44-3.87.13-.39.56-.6.95-.47s.6.56.47.95c-1.01 2.99-3.61 4.89-6.67 4.89"
            }
          )
        ]
      }
    )
  }
));
t.displayName = "AgencyElatedIcon";
export {
  t as AgencyElatedIcon,
  t as default
};
//# sourceMappingURL=index.js.map
